import CourseEditorPage from './CourseEditorPage';

export default function CreateCoursePage() {
  return <CourseEditorPage />;
}
